import { CustomerSchedule } from '@src/containers/Dealer/CustomerSchedule';
import type { CustomerScheduleConfigurationPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerScheduleConfigurationPanel({
  api,
  params,
}: LayoutPanelProps<CustomerScheduleConfigurationPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-schedule-configuration-panel"
    >
      <CustomerSchedule />
    </EntityAdminPanelShell>
  );
}
